import { LitElement, css, html } from 'lit';
import { when } from 'lit/directives/when.js';
import { customElement, property } from 'lit/decorators.js';
import { dlStyles } from '../../../styles';
import { StateController } from '../../../state';
import type { Category } from '../../entities';

@customElement('umb-market-package-sidebar-category')
export class UmbMarketPackageSidebarCategory extends LitElement {
  @property()
  category?: string;

  @property()
  altCategory?: string;

  #category?: Category;

  #altCategory?: Category;

  connectedCallback(): void {
    super.connectedCallback();

    this.#category = this.#categoryLookup(this.category);
    this.#altCategory = this.#categoryLookup(this.altCategory);
 }

  #categoryLookup = (id?: string) =>
    StateController.current.categories?.find(x => x.id === id);

  #categoryRender = (c: Category) => html`<a href="${c.link}">${c.name}</a>`;

  render() {
    return html`<div>
      <dl>
        ${when(
          this.#category,
          () => html` <div>
            <dt>Category</dt>
            <dd>
              ${this.#categoryRender(this.#category!)}
              ${when(this.#altCategory, () =>
                this.#categoryRender(this.#altCategory!)
              )}
            </dd>
          </div>`
        )}
      </dl>
    </div>`;
  }

  static styles = [
    dlStyles,
    css`
      :host {
        display: block;
      }

      a {
        margin-right: var(--s-spacer);
        display: inline-block;
      }
    `,
  ];
}
